import React from 'react';
import { useTranslation } from 'react-i18next';

// material

// ----------------------------------------------------------------------

export default function ReportProblem() {
  const { t } = useTranslation('translation')

  return (
    <div className="">
        <div className="pagedetails container">
            {/* <div id="feedback-button" className="hidden-print">
            <div className="row">
                <div className="col-sm-6 col-md-5 col-lg-4">
                    <details className="brdr-0">
                        <summary className="btn btn-default text-center">{t("Report a problem on this page")}</summary>
                        <div className="clearfix"></div>
                        <div className="well row">
                        <div>
                            <div className="gc-rprt-prblm">
                            <div className="gc-rprt-prblm-frm gc-rprt-prblm-tggl">
                                <form id="gc-rprt-prblm-form" action="/report-problem" method="POST">
                                    <input type="hidden" name="pageTitle" value="Check your eligibility for the Canada Greener Homes Grant"/>
                                    <input type="hidden" name="thanks" value="true"/>
                                    <input type="hidden" name="submissionPage" value="https://www.nrcan.gc.ca/energy-efficiency/homes/canada-greener-homes-initiative/canada-greener-homes-grant/canada-greener-homes-grant/check-your-eligibility-for-the-canada-greener-homes-grant/24050"/>
                                    <input type="hidden" name="currentPage" value="https://www.nrcan.gc.ca/energy-efficiency/homes/canada-greener-homes-initiative/canada-greener-homes-grant/canada-greener-homes-grant/check-your-eligibility-for-the-canada-greener-homes-grant/24050"/>
                                    <input type="hidden" name="submissionWebsite" value="www.nrcan.gc.ca"/>
                                    <input type="hidden" name="nid" value="24050"/>
                                    <input type="hidden" name="lang" value="en"/>
                                    <input name="subject" type="hidden" value="Report a problem on this page"/>
                                    <fieldset>
                                        <legend>
                                        <span className="field-name">{t("Please select all that apply:")}</span>
                                        </legend>
                                        <div className="checkbox">
                                        <label htmlFor="problem1">
                                            <input name="broken" id="problem1" type="checkbox" value="Yes"/> {t("A link, button or video is not working")} </label>
                                        </div>
                                        <div className="checkbox">
                                        <label htmlFor="problem2">
                                            <input name="spelling" id="problem2" type="checkbox" value="Yes"/> {t("It has a spelling mistake")} </label>
                                        </div>
                                        <div className="checkbox">
                                        <label htmlFor="problem3">
                                            <input name="wrong" id="problem3" type="checkbox" value="Yes"/> {t("Information is missing")} </label>
                                        </div>
                                        <div className="checkbox">
                                        <label htmlFor="problem4">
                                            <input name="outdated" id="problem4" type="checkbox" value="Yes"/> {t("Information is outdated or wrong")} </label>
                                        </div>
                                        <div className="checkbox">
                                        <label htmlFor="problem11">
                                            <input name="find" id="problem11" type="checkbox" value="Yes"/> {t("I can't find what I'm looking for")} </label>
                                        </div>
                                        <div className="checkbox">
                                        <label htmlFor="problem12">
                                            <input name="other" id="problem12" type="checkbox" value="Yes"/> {t("Other issue not in this list")} </label>
                                        </div>
                                    </fieldset>
                                    <button data-wb5-click="postback@#gc-rprt-prblm-form@" type="submit" className="btn btn-primary wb-toggle wb-init" data-toggle="{&quot;stateOff&quot;: &quot;hide&quot;, &quot;stateOn&quot;: &quot;show&quot;, &quot;selector&quot;: &quot;.gc-rprt-prblm-tggl&quot;}">{t("Submit")}</button>
                                </form>
                            </div>
                            <div className="gc-rprt-prblm-thnk gc-rprt-prblm-tggl hide">
                                <h3>{t("Thank you for your help!")}</h3>
                                <p></p>
                                <p>{t("You will not receive a reply. For enquiries,")} &nbsp; <a href="https://contact-contactez.nrcan-rncan.gc.ca/index.cfm?lang=eng">{t("contact us")}</a>. </p>
                                <p></p>
                            </div>
                            </div>
                        </div>
                        </div>
                    </details>
                </div>
                <div className="col-sm-4 col-md-3 col-sm-offset-2 col-md-offset-4 col-lg-offset-5">
                <div className="wb-share wb-init" data-wb-share="{&quot;lnkClass&quot;: &quot;btn btn-default btn-block&quot;}"></div>
                </div>
            </div>
            </div> */}
            <span/>
            {/* <div className="row">
            <div className="col-sm-12 col-md-6">
                <dl id="wb-dtmd">
                <dt>Date modified: </dt>
                <dd>
                    <time property="dateModified">2022-09-07</time>
                </dd>
                </dl>
            </div>
            </div> */}
        </div>
    </div>
  );
}
